import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Eyebrow } from '../ui/Eyebrow';
import { useBrand } from '../../contexts/BrandContext';
const included = [{
  label: 'Clinician review and written protocol',
  value: 'Included'
}, {
  label: 'Baseline 62-marker panel',
  value: 'Included annually'
}, {
  label: 'Medication, named pharmacy and lot',
  value: 'At published price'
}, {
  label: 'Follow-up panels and dose changes',
  value: 'Included'
}, {
  label: 'Shipping, including cold-chain',
  value: 'Free'
}];
const excluded = ['Dispensing fees added at checkout', 'Consult fees per message or per visit', 'Auto-escalating doses you did not approve', 'Annual contracts or cancellation calls', 'Overseas-sourced vials with no documentation'];
export function Transparency() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream" data-id="element-121" data-mp="3daqorqr5ue7t">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-122" data-mp="3d9pe3ne23tqm">
        <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-123" data-mp="3tu29mp6m0j5p">
          <div data-id="element-124" data-mp="2n96hfs9a9yj">
            <Eyebrow className="text-brick" data-id="element-125" data-mp="2mpo5xyp1jjz">Transparency</Eyebrow>
            <h2 className="mt-4 font-serif text-4xl leading-[1.06] text-ink md:text-[3.25rem]" data-id="element-126" data-mp="2l6amf4f9mlw">
              The price is the price.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-ink-soft" data-id="element-127" data-mp="cc0ujcu74a46">
              {brand.name} separates what you pay for clinical care from what you pay for
              medication, and publishes both. Your rate is held for twelve months from the day you
              start.
            </p>
            <Link to="/pricing" className="mt-8 inline-flex border-b border-brick pb-1 text-sm text-brick transition-colors duration-150 ease-republic hover:border-ink hover:text-ink" data-id="element-128" data-mp="3ks2pho0asyyj">
              See full pricing
            </Link>
          </div>

          <div className="grid gap-10 md:grid-cols-2" data-id="element-129" data-mp="1437048sor00u">
            <div data-id="element-130" data-mp="314unr81uaugv">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-131" data-mp="314cv0ledyydp">
                What is included
              </h3>
              <ul className="mt-5" data-id="element-132" data-mp="2w59osxmo6m45">
                {included.map(item => <li key={item.label} className="rule flex items-start gap-3 py-4" data-id="element-133" data-mp="3a4hpjuyhe2ag">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" strokeWidth={2} data-id="element-134" data-mp="3567urlgo53pd" />
                    <div data-id="element-135" data-mp="2hgdjh8bzzn78">
                      <p className="text-sm text-ink" data-id="element-136" data-mp="2hhoofbh6j0zx">{item.label}</p>
                      <p className="mt-1 text-sm text-ink-muted" data-id="element-137" data-mp="2dftkdz7v69ig">{item.value}</p>
                    </div>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-138" data-mp="2mfyfb9vvfffq">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-139" data-mp="2mfggc5htqn44">
                What {brand.name} does not do
              </h3>
              <ul className="mt-5" data-id="element-140" data-mp="1yoayxlw8jmrp">
                {excluded.map(item => <li key={item} className="rule flex items-start gap-3 py-4" data-id="element-141" data-mp="1tqrjiinsx3y6">
                    <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-muted" strokeWidth={2} data-id="element-142" data-mp="9879z1dcn4q9" />
                    <p className="text-sm text-ink-soft" data-id="element-143" data-mp="e10djlx3070r">{item}</p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}